import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

interface SimpleHeadlineProps {
  className?: string;
  title: string;
}

/**
 * Simple headline component that displays a headline with a given title.
 */
const SimpleHeadline: React.FC<SimpleHeadlineProps> = ({
  className,
  title,
}) => (
  <p
    className={cn(
      'text-text-light-bg-primary mindset-24 lg:mindset-28',
      className
    )}
  >
    <FormattedMessage id={title} />
  </p>
);

export default SimpleHeadline;
